// actions
const SET_CURRENCY = "SET_CURRENCY";
const SET_RATES = "SET_RATES";
const SET_SYMBOLS = "SET_SYMBOLS";

// action creators
export const setCurrency = (currency) => ({ type: SET_CURRENCY, currency });
export const setRates = (rates) => ({ type: SET_RATES, rates });
export const setSymbols = (symbols) => ({ type: SET_SYMBOLS, symbols });

const initialState = {
    selectedCurrency: "PLN",
    rates: { PLN: 1 },     // Default rate
    symbols: { PLN: "zł" } // ✅ Add default symbols
};

export default function currencyReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENCY:
            return { ...state, selectedCurrency: action.currency };
        case SET_RATES:
            return { ...state, rates: { ...state.rates, ...action.rates } };
        case SET_SYMBOLS:
            return { ...state, symbols: { ...state.symbols, ...action.symbols } };
        default:
            return state;
    }
}
